import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Button,
  Divider,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";

const OrderDetailsModal = ({ open, onClose, orderObj }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Detalhes do Pedido</DialogTitle>
    <DialogContent>
      <Typography variant="subtitle2" color="textSecondary" gutterBottom>
        Catálogo: {orderObj.catalogId || "-"}
      </Typography>
      <Divider style={{ margin: "8px 0" }} />
      {orderObj.products && orderObj.products.length > 0 && (
        <div>
          {orderObj.products.map((prod, idx) => (
            <Box key={idx} display="flex" alignItems="center" mb={2}>
              {prod.thumbnailUrl && (
                <img
                  src={prod.thumbnailUrl}
                  alt={prod.name}
                  style={{
                    width: 48,
                    height: 48,
                    objectFit: "cover",
                    borderRadius: 8,
                    marginRight: 12,
                  }}
                />
              )}
              <Box>
                <Typography
                  variant="body1"
                  style={{ fontWeight: 500 }}
                >{`${prod.name || prod.product_retailer_id}`}</Typography>
                <Typography variant="body2" color="textSecondary">
                  {`Quantidade: ${prod.quantity}`}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {`Preço: ${prod.price || prod.item_price}`}
                </Typography>
              </Box>
            </Box>
          ))}
        </div>
      )}
      <Divider style={{ margin: "8px 0" }} />
      <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
        {`Total: ${
          orderObj.total
            ? `R$${Number(orderObj.total).toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
              })}`
            : "-"
        }`}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button
        onClick={onClose}
        color="primary"
        variant="contained"
      >
        Fechar
      </Button>
    </DialogActions>
  </Dialog>
);

const OrderPreview = ({ order }) => {
  const [openModal, setOpenModal] = useState(false);

  if (!order) return null;

  let orderObj;
  try {
    orderObj = typeof order === "string" ? JSON.parse(order) : order;
  } catch {
    orderObj = {};
  }

  const totalItems = orderObj.products
    ? orderObj.products.reduce((sum, prod) => sum + (prod.quantity || 1), 0)
    : 0;

  const totalPrice =
    orderObj.total ||
    (orderObj.products
      ? orderObj.products.reduce(
          (sum, prod) => sum + (parseFloat(prod.price || prod.item_price || 0) * (prod.quantity || 1)),
          0
        )
      : 0);

  const time = orderObj.timestamp
    ? new Date(orderObj.timestamp).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    : "";

  const productThumb =
    orderObj.products && orderObj.products[0] && orderObj.products[0].thumbnailUrl
      ? orderObj.products[0].thumbnailUrl
      : null;

  return (
    <React.Fragment>
      <Card variant="outlined" style={{ minWidth: 350, margin: "8px 0", background: "inherit" }}>
        <CardContent style={{ paddingBottom: 8 }}>
          <Typography variant="subtitle2" color="textSecondary" gutterBottom>
            Pedido pelo Catálogo
          </Typography>
          <Divider style={{ margin: "4px 0 8px 0" }} />
          <Box display="flex" alignItems="center">
            {productThumb ? (
              <img
                src={productThumb}
                alt="Produto"
                style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 8, marginRight: 12 }}
              />
            ) : (
              <Box
                style={{
                  width: 48,
                  height: 48,
                  background: "#e0e0e0",
                  borderRadius: 8,
                  marginRight: 12,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ShoppingCartIcon style={{ fontSize: 32, color: "#888" }} />
              </Box>
            )}
            <Box flex={1}>
              <Typography variant="subtitle1" style={{ fontWeight: 600, display: "flex", alignItems: "center" }}>
                <ShoppingCartIcon style={{ fontSize: 18, marginRight: 4 }} />
                {totalItems} {totalItems === 1 ? "item" : "items"}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                {totalPrice
                  ? `R$${Number(totalPrice).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`
                  : ""}
              </Typography>
            </Box>
          </Box>
          <Box display="flex" justifyContent="flex-end" style={{ marginTop: 8 }}>
            <Typography variant="caption" color="textSecondary">
              {time}
            </Typography>
          </Box>
        </CardContent>
        <Divider />
        <Box display="flex" justifyContent="center" alignItems="center" style={{ padding: 5 }}>
          <Button
            variant="text"
            color="primary"
            style={{ fontWeight: 600, fontSize: 16 }}
            onClick={() => setOpenModal(true)}
          >
            Detalhes
          </Button>
        </Box>
      </Card>
      <OrderDetailsModal open={openModal} onClose={() => setOpenModal(false)} orderObj={orderObj} />
    </React.Fragment>
  );
};

export default OrderPreview;